import { StatusEnum } from 'constants/status';

import { STEP_NODE_STATUS } from '../PathToSubmission.constants';

export const NODE_STATUS_ICON = {
  [STEP_NODE_STATUS.DONE]: StatusEnum.SUCCESS,
  [STEP_NODE_STATUS.BLOCKING]: StatusEnum.ERROR,
};
